import { getTranslation } from '@mahawi/eshop-common/src/translation';
import { type IAdminCategory } from '@mahawi/eshop-common/src/types';
import { type RootState } from '@reducers';
import { FormInstance, Select } from 'antd';
import { type DefaultOptionType } from 'antd/lib/select';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getFilterOption, getFilterSort } from './select-filter';

function SelectCategoryOptions({
  fieldName,
  form,
  isDisabled = false,
  mode = undefined,
}: {
  fieldName: string;
  form: FormInstance;
  isDisabled?: boolean;
  mode?: 'multiple' | 'tags';
}): React.ReactElement {
  const Categories = useSelector((s: RootState) => s.Categories);
  const Language = useSelector((s: RootState) => s.Language);
  const [categories, setCategories] = useState<DefaultOptionType[]>([]);

  useEffect((): void => {
    if (!Categories.categories) {
      return;
    }

    const categoriesOptions: DefaultOptionType[] = Categories.categories.map(
      ({
        uuid,
        names,
        parentCategoryUUID,
      }: IAdminCategory): DefaultOptionType => {
        const name: string | null = getTranslation(
          names,
          Language.languageType,
        );
        const label = name ?? uuid;

        return {
          value: uuid,
          label: parentCategoryUUID === undefined ? `${label} (L1)` : label,
        };
      },
    );

    setCategories(categoriesOptions);
  }, [
    Categories.categories,
    Language.languageType?.code,
    Categories.updatedAt,
  ]);

  return (
    <Select
      value={form.getFieldValue(fieldName)}
      onChange={(value: string): void => form.setFieldValue(fieldName, value)}
      mode={mode}
      allowClear
      placeholder={
        mode === 'multiple' ? 'Select categories' : 'Select category'
      }
      disabled={isDisabled}
      showSearch={{
        autoClearSearchValue: false,
        filterOption: getFilterOption,
        filterSort: getFilterSort,
      }}
      options={categories}
    />
  );
}

export default SelectCategoryOptions;
